module.exports = __webpack_public_path__ + "assets/img/11_750.e9586620.jpg";